/* tslint:disable */
/* eslint-disable */
/**
 * Organization service API
 * Service for Organizations management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvestigationError } from './InvestigationError';
import {
    InvestigationErrorFromJSON,
    InvestigationErrorFromJSONTyped,
    InvestigationErrorToJSON,
} from './InvestigationError';

/**
 * 
 * @export
 * @interface OrgResearchReport
 */
export interface OrgResearchReport {
    /**
     * 
     * @type {number}
     * @memberof OrgResearchReport
     */
    score?: number;
    /**
     * 
     * @type {string}
     * @memberof OrgResearchReport
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgResearchReport
     */
    legalCompanyName?: string;
    /**
     * 
     * @type {string}
     * @memberof OrgResearchReport
     */
    headquartersAddress?: string;
    /**
     * 
     * @type {Array<InvestigationError>}
     * @memberof OrgResearchReport
     */
    errors?: Array<InvestigationError>;
}

/**
 * Check if a given object implements the OrgResearchReport interface.
 */
export function instanceOfOrgResearchReport(value: object): boolean {
    return true;
}

export function OrgResearchReportFromJSON(json: any): OrgResearchReport {
    return OrgResearchReportFromJSONTyped(json, false);
}

export function OrgResearchReportFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgResearchReport {
    if (json == null) {
        return json;
    }
    return {
        
        'score': json['score'] == null ? undefined : json['score'],
        'message': json['message'] == null ? undefined : json['message'],
        'legalCompanyName': json['legalCompanyName'] == null ? undefined : json['legalCompanyName'],
        'headquartersAddress': json['headquartersAddress'] == null ? undefined : json['headquartersAddress'],
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(InvestigationErrorFromJSON)),
    };
}

export function OrgResearchReportToJSON(value?: OrgResearchReport | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'score': value['score'],
        'message': value['message'],
        'legalCompanyName': value['legalCompanyName'],
        'headquartersAddress': value['headquartersAddress'],
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(InvestigationErrorToJSON)),
    };
}

